import {v4 as uuid} from 'uuid';
import api from '../index';

export type CancellationReason = 1 | 2 | 3 | 4;

const contractUpdaters = {
  cancel: async ({
    contractId,
    cancellationReason,
    cancellationMessage,
  }: {
    contractId: string;
    cancellationReason: CancellationReason;
    cancellationMessage: string;
  }) => {
    // Generate the idempotency key once per call so any retries reuse it;
    // the backend dedupes on this value.
    const body = {
      cancellation_reason: cancellationReason,
      cancellation_message: cancellationMessage,
      idempotency_key: uuid(),
    };
    // The `data` arg must be non-null for jsonapi-react to invoke
    // customSerializer; passing null short-circuits before serialization
    // runs and the backend receives an empty body.
    return api.put(`/contracts/${contractId}/cancel`, body, {
      customSerializer: () => body,
    });
  },

  updateDueDate: async ({
    contractId,
    dueAt,
  }: {
    contractId: string;
    dueAt: string;
  }) => {
    return api.patch(
      `/contracts/${contractId}`,
      {dueAt},
      {
        customSerializer: () => ({
          data: {
            type: 'contracts',
            id: contractId,
            attributes: {due_at: dueAt},
          },
        }),
      }
    );
  },

  batchUpdateDueDate: async ({
    contractIds,
    dueAt,
  }: {
    contractIds: string[];
    dueAt: string;
  }) => {
    return api.post(
      `/contracts/batch_update_due_date`,
      {contractIds, dueAt},
      {
        customSerializer: () => ({
          data: {
            type: 'contract_due_date_batches',
            attributes: {contract_ids: contractIds, due_at: dueAt},
          },
        }),
      }
    );
  },

  complete: async ({contractId}: {contractId: string}) => {
    return api.put(`/contracts/${contractId}/complete`, null);
  },
};

export default contractUpdaters;
